import { isValid } from "date-fns"
import { context } from "../.."


export default function FieldDate ({formik, field, disabled = false, autoFocus = false}) {

    const label = context.formatLabel(field.label)

    return (
        <div className="form-field field-date">
            {label ? <label htmlFor={field.name}>{label}</label> : null}

            <input
                id={field.name}
                type="date"
                name={field.name}
                autoFocus={autoFocus}
                disabled={disabled}
                value={formik.values[field.name]}
                onChange={(e) => {
                    
                    var date = new Date(e.target.value)
                    
                    // Limit years to 4 digits
                    if (isValid(date) && date.getFullYear() > 9999) {
                        return
                    }
                    
                    formik.setFieldValue(field.name, e.target.value)
                }} />

                {field.helpText ? <span className="help-text">{field.helpText}</span> : null}
        </div>
    )
}